import React from "react";
import ReactDOM from "react-dom/client";
import "@/lib/apiClient";
import "@/index.css";
import App from "@/App";
import { AccountantProvider } from "@/contexts/AccountantContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { ToastProvider } from "@/components/kipa";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AccountantProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </AccountantProvider>
    </AuthProvider>
  </React.StrictMode>,
);

// Register service worker (for web push + PWA install)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
